import axios from 'axios'

async function getPdf(file: string): Promise<Blob> {
    return (
        await axios.get(file, {
            responseType: 'blob',
        })
    ).data
}

export function readerFile(file: File | string): string {
    if (typeof file === 'string') return file
    return window.URL.createObjectURL(file)
}

export default async function downloadPdf(file: File | string, name?: string): Promise<void> {
    let auxFile = file
    if (typeof file === 'string') {
        let fileName = 'catalog.pdf'
        if (name) fileName = `${name}.pdf`
        auxFile = new File([await getPdf(file)], fileName)
    }
    const link = document.createElement('a')
    link.href = readerFile(auxFile)
    if (typeof auxFile !== 'string') {
        link.setAttribute('download', auxFile.name)
    } else {
        link.href = auxFile
        link.setAttribute('download', auxFile)
    }
    document.body.appendChild(link)
    link.click()
    link.parentNode?.removeChild(link)
}
